/* istanbul ignore file */
export default class BraintreeHostedFields {
	constructor(client, hostedFields, isAsmAgentLoggedIn) {
		this.client = client;
		this.hostedFields = hostedFields;
		this.hostedFieldsInstance = null;
		this.isAsmAgentLoggedIn = isAsmAgentLoggedIn;
		this.supportedCardTypes = [];
		this.cardsMap = {
			'American Express': 'american-express',
			'UK Maestro': 'maestro',
			Maestro: 'maestro',
			Visa: 'visa',
			Mastercard: 'mastercard',
		};
	}

	async create() {
		const options = this.buildHostedFieldsOptions(this.client);
		this.hostedFieldsInstance = await this.hostedFields.create(options);
		this.supportedCardTypes =
			await this.hostedFieldsInstance.getSupportedCardTypes();
		this.showSupportedCardsIcons(this.supportedCardTypes);
		this.hostedFieldsInstance.on(
			'cardTypeChange',
			this.onCardTypeChange.bind(this),
		);
		this.hostedFieldsInstance.on('validityChange', this.onValidityChange);
		this.addNoMouseflowClassForInputFields(this.hostedFieldsInstance);
		return this.hostedFieldsInstance;
	}

	buildHostedFieldsOptions(client) {
		const cardNumberAndCvvInputType = this.isAsmAgentLoggedIn
			? 'password'
			: 'tel';
		const cardHolderNamePlaceholder = document.getElementById(
			'paymentCardholderName',
		).dataset.cardHolderNameInputPlaceholder;
		return {
			client,
			styles: {
				input: {
					'font-size': '1rem',
					height: '30px',
					'font-family': 'Roboto, -apple-system, "system-ui", sans-serif',
				},
				'input.invalid': {
					color: '#e4002c',
				},
				'input:-internal-autofill-selected': {
					'background-color': '#ffffff!important',
				},
				'input:autofill': {
					'background-color': '#ffffff!important',
				},
			},
			fields: {
				cardholderName: {
					selector: '#paymentCardholderName',
					placeholder: cardHolderNamePlaceholder,
				},
				number: {
					container: '#paymentCardNumber',
					placeholder: '4111 1111 1111 1111',
					type: cardNumberAndCvvInputType,
					formatInput: !this.isAsmAgentLoggedIn,
				},
				cvv: {
					container: '#paymentCvv',
					placeholder: '123',
					type: cardNumberAndCvvInputType,
				},
				expirationDate: {
					container: '#paymentExpirationDate',
					placeholder: 'mm/yyyy',
				},
			},
		};
	}

	showSupportedCardsIcons(cards = []) {
		const bemElement = 'checkout-payment-methods__icon';
		cards.forEach(card => {
			const cardType = this.cardsMap[card];
			const cardIconElement = document.querySelector(
				`.${bemElement}.${cardType}`,
			);
			cardIconElement?.removeAttribute('hidden');
		});
	}

	getIsCardSupported(card, supportedCards = []) {
		return supportedCards.includes(card);
	}

	onCardTypeChange({ cards }) {
		const icon = document.getElementById('credit-card-icon');
		const creditCardIconElementClass =
			'braintree-payment-form__credit-card-icon';
		icon.className = creditCardIconElementClass;
		this.hideErrorMessage(icon);
		if (cards.length === 1) {
			const [card] = cards;
			const { niceType } = card;
			const isCardSupported = this.getIsCardSupported(
				niceType,
				this.supportedCardTypes,
			);
			if (!isCardSupported) {
				this.showErrorMessage(icon);
			}

			icon.className += ` ${creditCardIconElementClass} ${this.cardsMap[niceType]}`;
			const isAmericanExpress = card.code.size === 4;
			const cvvValue = isAmericanExpress ? '1234' : '123';
			this.hostedFieldsInstance.setAttribute({
				field: 'cvv',
				attribute: 'placeholder',
				value: cvvValue,
			});
		}
	}

	hideErrorMessage(element) {
		const event = new Event('hide-error-message', { bubbles: true });
		element.dispatchEvent(event);
	}

	showErrorMessage(element) {
		const event = new CustomEvent('show-error-message', {
			detail: 'unsupported-card-error-message',
			bubbles: true,
		});
		element.dispatchEvent(event);
	}

	onValidityChange(event) {
		const field = event.fields[event.emittedBy];
		const fieldContainerClassList = field.container.classList;
		fieldContainerClassList.remove('is-valid');
		fieldContainerClassList.remove('is-invalid');

		if (field.isValid) {
			field.container.classList.add('is-valid');
		} else if (field.isPotentiallyValid) {
			// skip adding classes if the field is
			// not valid, but is potentially valid
		} else {
			field.container.classList.add('is-invalid');
		}
	}

	addNoMouseflowClassForInputFields(hostedFields) {
		const inputFields = ['cardholderName', 'number', 'cvv', 'expirationDate'];
		inputFields.forEach(field => {
			this.addClassToInputField(hostedFields, field, 'no-mouseflow');
		});
	}

	addClassToInputField(hostedFields, inputField, className) {
		hostedFields.addClass(inputField, className, addClassError => {
			if (addClassError) {
				// eslint-disable-next-line no-console
				console.error(
					'[Braintree Hosted Fields add class error]:',
					addClassError,
				);
			}
		});
	}
}
